// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, cloneElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';

import './Subnav.less';

/**
 * `Subnav` component is used when you need a second level navigation under [Tabs](#!/Tabs) on the screen.
 */
const Subnav = ({ baseClassName, className, children, ...props }) => (
    <div className={classNames(baseClassName, className)} {...props}>
        {children}
    </div>
);

Subnav.propTypes = {
    /**
     * Subnav items
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

Subnav.defaultProps = {
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}subnav`,
};

/**
 * SubnavItem component.
 */
const SubnavItem = ({ baseClassName, className, active, children, ...props }) => cloneElement(children, {
    className: classNames(baseClassName, active && `${baseClassName}--active`, className),
    ...props,
});

SubnavItem.propTypes = {
    /**
     * Is item active.
     */
    active: PropTypes.bool,
    /**
     * Content of the item
     */
    children: PropTypes.element.isRequired,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

SubnavItem.defaultProps = {
    className: null,
    baseClassName: `${CLS_PREFIX}subnav__item`,
};

export default Subnav;
export { SubnavItem };



// WEBPACK FOOTER //
// ./components/Subnav/Subnav.js